__turbopack_context__.v({
  "content": "InfoStrip-module-scss-module__66Hpra__content",
  "description": "InfoStrip-module-scss-module__66Hpra__description",
  "fade-in": "InfoStrip-module-scss-module__66Hpra__fade-in",
  "heading": "InfoStrip-module-scss-module__66Hpra__heading",
  "logotype": "InfoStrip-module-scss-module__66Hpra__logotype",
  "no-transform": "InfoStrip-module-scss-module__66Hpra__no-transform",
  "rotate": "InfoStrip-module-scss-module__66Hpra__rotate",
  "strip": "InfoStrip-module-scss-module__66Hpra__strip",
});
